import { useState } from 'react';
import {
    Box,
    Button,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import HowToReg from '@mui/icons-material/HowToReg';
import { Controller } from 'react-hook-form';

import UserModal from './UserModal';

const ContactUserSection = ({
    title = '担当者',
    isEditMode = true,
    control,
    register,
    setValue,
    errors
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    /*const handleSelectUser = (user) => {
        setValue('user_fullname', user.username, { shouldDirty: true });
        setValue('user_email', user.email ?? '', { shouldDirty: true });
        setValue('user_phone', user.phone_number ?? '', { shouldDirty: true });

        setIsModalOpen(false);
    };*/
    const handleSelectUser = (user) => {
        setValue(
            'user_fullname',
            `${user.last_name ?? ''}${user.first_name ?? ''}`,
            { shouldDirty: true }
        );

        setValue('user_email', user.email ?? '', { shouldDirty: true });
        setValue('user_phone', user.phone_number ?? '', { shouldDirty: true });

        setIsModalOpen(false);
    };

    return (
        <>
            <Typography component="h2" variant="h4" mb={2}>
                {title}
            </Typography>

            <Stack
                direction="row"
                spacing={1}
                mb={2}
                mt={1}
                alignItems="flex-start"
            >
                <Controller
                    name="user_fullname"
                    control={control}
                    rules={{
                        maxLength: {
                            value: 100,
                            message: '100文字以内で入力してください',
                        },
                    }}
                    render={({ field, fieldState }) => (
                        <TextField
                            {...field}
                            fullWidth
                            label="担当者名"
                            disabled={!isEditMode}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            inputProps={{ maxLength: 100 }}
                            multiline
                        />
                    )}
                />

                <Button
                    variant="outlined"
                    sx={{ minWidth: 130 }}
                    startIcon={<HowToReg />}
                    onClick={() => setIsModalOpen(true)}
                    disabled={!isEditMode}
                >
                    担当者を選択
                </Button>
            </Stack>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    rowGap: 2,
                    columnGap: 1,
                }}
            >
                <TextField
                    label="メールアドレス"
                    disabled={!isEditMode}
                    inputProps={{ maxLength: 255 }}
                    {...register('user_email', {
                        maxLength: {
                            value: 255,
                            message: '255文字以内で入力してください',
                        },
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: '正しいメールアドレスを入力してください',
                        },
                    })}
                    error={!!errors.user_email}
                    helperText={errors.user_email?.message}
                />

                <TextField
                    label="電話番号"
                    disabled={!isEditMode}
                    inputProps={{ maxLength: 20 }}
                    {...register('user_phone', {
                        maxLength: {
                            value: 20,
                            message: '20文字以内で入力してください',
                        },
                        pattern: {
                            value: /^(?:\+?\d{1,4}[-\s]?)?0?\d{1,4}[-\s]?\d{1,4}[-\s]?\d{4}$/,
                            message: '電話番号形式が正しくありません',
                        },
                    })}
                    error={!!errors.user_phone}
                    helperText={errors.user_phone?.message}
                />
            </Box>

            <UserModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSelectUser={handleSelectUser}
            />
        </>
    );
};

export default ContactUserSection;